import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=2fc7a378&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"
import style0 from "./LoginAdmin.vue?vue&type=style&index=0&id=2fc7a378&prod&lang=scss"
import style1 from "./LoginAdmin.vue?vue&type=style&index=1&id=2fc7a378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7a378",
  null
  
)

export default component.exports